import { render, staticRenderFns } from "./pointOfSale.vue?vue&type=template&id=5531f536"
import script from "./pointOfSale.vue?vue&type=script&lang=js"
export * from "./pointOfSale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports